<template>
  <div>
    <v-card id="card" class="card-text rounded-0" color="" style="">
      <div :class="getItemBackColor(item)" class="px-1 py-1">
        <v-row>
          <v-col class="my-auto py-0" @click="clickItem">
            <v-row>
              <v-col cols="">
                <v-row>
                  <v-col cols="6" class="">
                    <div class="d-flex flex-column">
                      <span>{{ item.PersonName }}</span>
                      <span class="">({{ item.PERNO }})</span>
                    </div>
                  </v-col>
                  <v-col cols="6" class="">
                    <span class="">{{ item.PresenceText }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="d-flex my-auto py-0" cols="auto">
            <v-btn icon @click="show = !show" class="card-text">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-expand-transition class="">
          <div v-show="show" class="mt-1">
            <v-row @click="clickItem">
              <v-col>
                <v-row>
                  <v-col cols="6" class="my-auto"
                    >{{ $t("SectionCode") }} :
                    <span class="">{{ item.Section }}</span>
                  </v-col>
                  <v-col cols="6" class="my-auto"
                    >{{ $t("SectionName") }} :
                    <span class="">{{ item.SectionName }}</span>
                  </v-col>
                  <v-col cols="6" class="my-auto"
                    >{{ $t("Start") }} :
                    <span class="">{{ item.StartTime }}</span>
                  </v-col>
                  <v-col cols="6" class="my-auto"
                    >{{ $t("End") }} :
                    <span class="">{{ item.EndTime }}</span>
                  </v-col>
                  <v-col cols="12" class="my-auto"
                    >{{ $t("description") }} :
                    <span class="">{{ item.Description }}</span>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="auto py-0">
                <div style="width: 36px; height: 36px"></div>
              </v-col>
            </v-row>
          </div>
          
        </v-expand-transition>
        
      </div>
      <v-divider class="bg-white pa-0 ma-0"></v-divider>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {},
  data() {
    return {
      show: false,
      rowColors: [
        "PaleVioletRed", //   غیبت
        "Orange", //   ماموریت روزانه
        "OrangeRed", //   ماموریت روزانه - تأیید نشده
        "DarkOrange", //   ماموریت روزانه - تأیید شده - انتقال داده نشده
        "LightBlue", //   ماموریت ساعتی
        "SlateBlue", //   ماموریت ساعتی - تأیید نشده
        "DodgerBlue", //   ماموریت ساعتی - تأیید شده - انتقال داده نشده
        "ForestGreen", //   مرخصی روزانه
        "LightSeaGreen", //   مرخصی روزانه - تأیید نشده
        "GreenYellow", //   مرخصی روزانه - تأیید شده - انتقال داده نشده
        "LightSeaGreen", //   مرخصی ساعتی
        "DarkOliveGreen", //   مرخصی ساعتی - تأیید نشده
        "DarkSeaGreen", //   مرخصی ساعتی - تأیید شده - انتقال داده نشده
        "DarkMagenta", //   تاخیر سرویس
        "White", //   حضور در سازمان
      ],
    };
  },
  methods: {
    getItemBackColor(item) {
      return this.rowColors[item.PresenceType];
    },
    clickItem() {
      this.$emit("onClickItem", this.item);
    },
  },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}

.bg-white{
  background-color: white;
}
</style>